import React, { useContext } from 'react';
import { MdClose } from 'react-icons/md';
import { SidebarContainer, SidebarUl, SidebarLi, Icon, Backdrop } from './sidebar-styles';
import { NavContext } from '../../contexts/NavContext';
import { Link } from 'react-router-dom';

const Sidebar = () => {
	const { showSidebar, setShowSidebar } = useContext(NavContext);
	const handleClick = () => setShowSidebar(!showSidebar);
	const ScrollToTop = () => {
		window.scrollTo(0, 0);
	};

	const sidebarLinkStyles = {
		textDecoration: 'none',
		width: '250px'
	};

	return (
		<React.Fragment>
			<div onClick={handleClick}>
				<Backdrop show={showSidebar} />
				<SidebarContainer show={showSidebar}>
					<Icon>
						<MdClose />
					</Icon>
					<SidebarUl>
						<Link to="/home" style={sidebarLinkStyles} onClick={ScrollToTop}>
							<SidebarLi>Home</SidebarLi>
						</Link>
						<Link to="/membership" style={sidebarLinkStyles} onClick={ScrollToTop}>
							<SidebarLi>Memberships</SidebarLi>
						</Link>
						<Link to="/all-gear" style={sidebarLinkStyles} onClick={ScrollToTop}>
							<SidebarLi>Gear</SidebarLi>
						</Link>
						<Link to="/locations" style={sidebarLinkStyles} onClick={ScrollToTop}>
							<SidebarLi>Locations</SidebarLi>
						</Link>
						<Link to="/our-mission" style={sidebarLinkStyles} onClick={ScrollToTop}>
							<SidebarLi>Our Mission</SidebarLi>
						</Link>
					</SidebarUl>
				</SidebarContainer>
			</div>
		</React.Fragment>
	);
};

export default Sidebar;
